import { render, staticRenderFns } from "./u-file-input-filled-pill.vue?vue&type=template&id=21adca15&scoped=true&"
import script from "./u-file-input-filled-pill.vue?vue&type=script&lang=js&"
export * from "./u-file-input-filled-pill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21adca15",
  null
  
)

export default component.exports